import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FlashMessage, Radio } from "../../../components/common";
import { editAdminRequest } from "../../../reducers/company/companyAdmins.reducer";
import { FormControl, FormLabel, Grid, Typography } from "@material-ui/core";
import { Button, Modal } from "../../../components/common";
import { useForm } from "react-hook-form";
import _ from "lodash";
import { companyUserAccessLevel } from "../../../utils/appConstants";
import Avatar from "../../../components/common/AvtarImage";
interface Props {
  data: any;
  loading: boolean;
  visible: boolean;
  handleClose: () => void;
}
type Inputs = {
  companyHandlerId: number;
  accessLevel: string;
  chooseRole: string;
};

const EditAdminModal = ({ visible, handleClose, data }: Props) => {
  const dispatch = useDispatch();

  const { formState: { errors }, control, reset } = useForm<Inputs>({
    defaultValues: { chooseRole: data?.role || "" },
  });
  const [accessLevel, setAccessLevel] = useState<string>("");
  const {
    companyAdmins: { updateFlag, editLoading, updateMessage },
  } = useSelector(({ company }: any) => company);

  //  Delete admin success Hook
  useEffect(() => {
    const role = data?.role || "";
    setAccessLevel(role);
    reset({ chooseRole: role });

    // eslint-disable-next-line
  }, [data?.role]);

  //  Delete admin success Hook
  useEffect(() => {
    if (updateFlag === "success") {
      handleClose();
      FlashMessage(updateMessage);
    } else {
      FlashMessage(updateMessage, "error");
    }

    // eslint-disable-next-line
  }, [updateFlag, updateMessage]);

  const accessRole =
    companyUserAccessLevel.find((row) => row.value === data.role)?.label || "";
  return (
    <Modal
      visible={visible}
      size="medium"
      title="Edit Access"
      className="admin-main-modal admin-profile-add-modal"
      closeButton={visible}
      onClose={handleClose}
      closeOnBackDrop={false}
    >
      <div className="admin-info">
        <div className="admin-avatar">
          <Avatar
            src={data.profile_image}
            size="sm"
            onClick={() => _handleOpenProfileModal()}
          />
        </div>
        <div className="admin-name">
          <Typography className="heading-title">{data.name}</Typography>
          <Typography className="heading-role">{accessRole}</Typography>
        </div>
      </div>
      <Grid container xs={12} className="edit-admin-modal-wrapper">
        <form className="invite-admin-form">
          <FormControl>
            <div className="radio-wrapper">
              <FormLabel id="choose-admin-role-label">Choose role</FormLabel>
              <Radio
                name="chooseRole"
                control={control}
                validationObj={errors}
                labelPlacement="end"
                defaultValue={data?.role}
                options={companyUserAccessLevel}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setAccessLevel(_.get(e, "target.value", ""))
                }
                rules={{
                  required: {
                    value: true,
                    message: "Please select a role",
                  },
                }}
              />
            </div>
          </FormControl>
        </form>
        <Grid
          item
          spacing={4}
          xs={12}
          className="text-center action-button-wrapper"
        >
          <Button
            loading={editLoading}
            className="primary-btn dlt-btn delete-video-yes text-uppercase"
            onClick={() =>
              dispatch(
                editAdminRequest({
                  id: data.id,
                  name: data.name,
                  status: data.status,
                  profile_image: data.profile_image,
                  role: accessLevel,
                })
              )
            }
          >
            Save
          </Button>
          <Button
            disabled={editLoading}
            className="primary-btn btn-transparent dlt-btn delete-video-no"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default EditAdminModal;
